export default __webpack_public_path__ + "static/media/yu.7e2c0e5d.jpg";